// frontend/src/pages/public/DocsLayout.jsx
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Container } from "../../marketing/ui";
import { DOCS } from "../../marketing/docsContent";
import { cx } from "../../marketing/ui";

export default function DocsLayout() {
  const linkClass = ({ isActive }) =>
    cx(
      "block rounded-lg px-3 py-2 text-sm",
      isActive ? "bg-brand-50 font-semibold text-brand-700" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
    );

  return (
    <Container className="py-12">
      <div className="md:grid md:grid-cols-[220px_minmax(0,1fr)] md:gap-10">
        {/* Sidebar — left column from md (768px) up; stacks on top below that. */}
        <aside className="mb-8 md:mb-0">
          <nav className="md:sticky md:top-24">
            <p className="px-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
              Documentation
            </p>
            <div className="mt-2 space-y-1">
              <NavLink to="/docs" end className={linkClass}>
                Overview
              </NavLink>
              {DOCS.map((d) => (
                <NavLink key={d.slug} to={`/docs/${d.slug}`} className={linkClass}>
                  {d.title}
                </NavLink>
              ))}
            </div>
          </nav>
        </aside>

        {/* Content */}
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </Container>
  );
}
